module.exports = __webpack_public_path__ + "media/components/stylesheets/Gordita-Bold-0d227fdf2f8e319c2e4c7a5fa3500838.woff";